import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  GithubAuthProvider,
  GoogleAuthProvider,
  TwitterAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";

// Antd
import { message } from "antd";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Global handling of signin popups
const handleSignInWithPopup = (
  provider: GoogleAuthProvider | TwitterAuthProvider | GithubAuthProvider
) => {
  signInWithPopup(auth, provider)
    .then((res) => {
      return res;
    })
    .catch(({ code }) => {
      console.log("Error code", code);
      if (code === "auth/account-exists-with-different-credential") {
        return message.error(
          "An account with this email address exists through a different login method"
        );
      }

      message.error("Something went wrong. Please try again.");
    });
};

const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = () => {
  handleSignInWithPopup(googleProvider);
};

const twitterProvider = new TwitterAuthProvider();
const signInWithTwitter = () => {
  handleSignInWithPopup(twitterProvider);
};

const githubProvider = new GithubAuthProvider();
const signInWithGithub = () => {
  handleSignInWithPopup(githubProvider);
};

export const registerWithEmailAndPassword = async (
  email: string,
  password: string
) => {
  createUserWithEmailAndPassword(auth, email, password).catch(({ code }) => {
    console.log("Error", code);

    if (code === "auth/weak-password") {
      message.error("Please choose a stronger password");
    } else if (code === "auth/email-already-in-use") {
      message.error("An account already exists under this email address");
    } else {
      message.error("Something went wrong. Please try again.");
    }
  });
};

export const signInWithEmailAndPassword = async (
  email: string,
  password: string
) => {
  firebaseSignInWithEmailAndPassword(auth, email, password).catch(
    ({ code }) => {
      console.log("Error", code);

      if (code === "auth/user-not-found") {
        message.error("User not found. Please register first");
      } else if (code === "auth/invalid-email") {
        message.error("Invalid email address");
      } else {
        message.error("Something went wrong. Please try again.");
      }
    }
  );
};

export const sendPasswordResetEmail = async (email: string) => {
  firebaseSendPasswordResetEmail(auth, email)
    .then(() =>
      message.success(
        "If there is an account under this email address, you will receive an email shortly."
      )
    )
    .catch(({ code }) => {
      console.log("Error", code);

      message.error("Something went wrong. Please try again.");
    });
};

const logout = () => {
  signOut(auth);
};
export { auth, logout, signInWithGithub, signInWithGoogle, signInWithTwitter };
